import { PortfolioTaskStatus } from "api/generated";

export { PortfolioTaskStatus };

export const PORTFOLIO_TASK_STATUS_LABEL: Record<PortfolioTaskStatus, string> =
  {
    [PortfolioTaskStatus.concept]: "Concept",
    [PortfolioTaskStatus.planned]: "Gepland",
    [PortfolioTaskStatus.open]: "Open",
    [PortfolioTaskStatus.closed]: "Gesloten",
  };

export const PORTFOLIO_TASK_STATUS_COLOR: Record<PortfolioTaskStatus, string> =
  {
    [PortfolioTaskStatus.concept]: "portfolio-task-concept",
    [PortfolioTaskStatus.planned]: "portfolio-task-planned",
    [PortfolioTaskStatus.open]: "portfolio-task-open",
    [PortfolioTaskStatus.closed]: "portfolio-task-closed",
  };
